require('inputmask');
import sbjs from 'sourcebuster';
window.sbjs = sbjs;
sbjs.init();

require('./components/modal');

const toolsLandingPage = {
    account: function (successModal, value, nameForm) {
        $(`.modal_wrap[data-modal=${nameForm}]`).find('input').removeClass('input_error');
        $(`.modal_wrap[data-modal=${nameForm}]`).find('.text_problem').remove();

        $.post(request[nameForm], value, function (data) {
            if (data.status == 'ok') {
                if (typeof data.error !== 'undefined') {
                    $('.modal_wrap .js__disabled').removeClass('js__disabled');

                    if (data.error == 'error_phone_verify') {
                        $('.modal_wrap[data-modal="loginAccount"] .js_close_modal').trigger('click');
                        $('.modal_wrap[data-modal="registerAccountValid"] .js__open_window_now').trigger('click');
                        $('.modal_wrap[data-modal="registerAccountValid"] .js_user_id').val(data.user_id);
                    } else {
                        $(`.modal_wrap[data-modal=${nameForm}]`).find(`input[data-errorReqiest=${data.error}]`).addClass('input_error')
                            .after(`<p class="text_problem text_error">${errorText[data.error]}</p>`);
                    }
                } else {
                    document.location.reload();
                    toolsLandingPage.sendSuccess(successModal, true);
                }
            }
        });
    },

    passwordForgot: function (successModal, value, nameForm) {
        $(`.modal_wrap[data-modal=${nameForm}]`).find('input').removeClass('input_error');
        $(`.modal_wrap[data-modal=${nameForm}]`).find('.text_problem').remove();
        $(`.modal_wrap[data-modal=${nameForm}]`).find('.type_contact').remove();

        $.post(request.passwordForgot, value, function (data) {
            if (data.status == 'ok') {
                if (typeof data.error !== 'undefined') {
                    $('.modal_wrap .js__disabled').removeClass('js__disabled');

                    $(`.modal_wrap[data-modal=${nameForm}]`).find(`input[data-errorReqiest=${data.error}]`).addClass('input_error')
                        .after(`<p class="text_problem text_error">${errorText[data.error]}</p>`);
                } else if (typeof data.user_email !== 'undefined' && typeof data.user_phone !== 'undefined') {
                    $(`.modal_wrap[data-modal=${nameForm}]`).find('.input_wrapper').hide()
                        .before(`<div class="type_contact">
                                <div class="input_contact">
                                    <input type="radio" id="email_user" name="type_contact" value="email">
                                    <label for="email_user">${data.user_email}</label>
                                </div>
                                <div class="input_contact">
                                    <input type="radio" id="phone_user" name="type_contact" value="phone">
                                    <label for="phone_user">${data.user_phone}</label>
                                </div>
                            </div>`);

                    $(`.modal_wrap[data-modal=${nameForm}]`).find('.type_contact_text').show();
                    $(`.modal_wrap[data-modal=${nameForm}]`).find('.text_forgot').hide();
                } else {
                    toolsLandingPage.sendSuccess(successModal, true);
                    $(`.modal_wrap[data-modal=${nameForm}]`).find('.input_wrapper').show();
                    $(`.modal_wrap[data-modal=${nameForm}]`).find('.type_contact').remove();
                    $(`.modal_wrap[data-modal=${nameForm}]`).find('.type_contact_text').hide();
                    $(`.modal_wrap[data-modal=${nameForm}]`).find('.text_forgot').show();
                }
            }
        });
    },

    registerAccount: function (successModal, value, nameForm) {
        $(`.modal_wrap[data-modal=${nameForm}]`).find('input').removeClass('input_error');
        $(`.modal_wrap[data-modal=${nameForm}]`).find('.text_problem').remove();

        $.post(request[nameForm], value, function (data) {
            if (data.status == 'ok') {
                if (typeof data.error !== 'undefined') {
                    $('.modal_wrap .js__disabled').removeClass('js__disabled');

                    $(`.modal_wrap[data-modal=${nameForm}]`).find(`input[data-errorReqiest=${data.error}]`).addClass('input_error')
                        .after(`<p class="text_problem text_error">${errorText[data.error]}</p>`);
                } else {
                    $('.modal_wrap[data-modal="registerAccount"] .js_close_modal').trigger('click');
                    $('.modal_wrap[data-modal="registerAccountValid"] .js__open_window_now').trigger('click');
                    $('.modal_wrap[data-modal="registerAccountValid"] .js_user_id').val(data.user_id);
                }
            }
        });
    },

    registerAccountValid: function registerAccountValid(successModal, value, nameForm) {
        $(`.modal_wrap[data-modal=${nameForm}]`).find('input').removeClass('input_error');
        $(`.modal_wrap[data-modal=${nameForm}]`).find('.text_problem').remove();

        $.post(request.verifyPhone, value, function (data) {
            if (data.status == 'ok') {
                if (typeof data.error !== 'undefined') {
                    $('.modal_wrap .js__disabled').removeClass('js__disabled');

                    $(`.modal_wrap[data-modal=${nameForm}]`).find(`input[data-errorReqiest=${data.error}]`).addClass('input_error')
                        .after(`<p class="text_problem text_error">${errorText[data.error]}</p>`);
                } else {
                    document.location.reload();
                    toolsLandingPage.sendSuccess(successModal, true);

                    dataLayer.push({ ecommerce: null });
                    dataLayer.push({
                        'event': 'sign_up'
                    });
                }
            }
        });
    },

    appointVerifyPhone: function (successModal, value, nameForm) {
        $(`.modal_wrap[data-modal=${nameForm}]`).find('input').removeClass('input_error');
        $(`.modal_wrap[data-modal=${nameForm}]`).find('.text_problem').remove();

        $.post(request.appointVerifyPhone, value, function (data) {
            if (data.status == 'ok') {
                if (typeof data.error !== 'undefined') {
                    $('.modal_wrap .js__disabled').removeClass('js__disabled');

                    $(`.modal_wrap[data-modal=${nameForm}]`).find(`input[data-errorReqiest=${data.error}]`).addClass('input_error')
                        .after(`<p class="text_problem text_error">${errorText[data.error]}</p>`);
                } else {
                    toolsLandingPage.sendSuccess(successModal, false, 'signService');

                    const gtmInfo = JSON.parse(value.gtm_info);
                    dataLayer.push(gtmInfo);
                }
            }
        });
    },

    sendForm: function (value, successModal, typeLanding) {
        $.post(request.sendFormLandingPage, value, function (data) {
            if (data.status == 'ok') {

                dataLayer.push({
                    'event': 'form_submit',
                    'form_name': typeLanding,
                    'location': "main_form",
                    'service_city': value.city,
                    'service_address': "undefined",
                    'type': "undefined"
                });
                toolsLandingPage.sendSuccess(successModal);
            }
        });
    },

    registerAccountB2B: function (successModal, value, nameForm) {
        $.post(request.registerAccountB2B, value, function (data) {
            if (data.status == 'ok') {
                if (typeof data.error !== 'undefined') {
                    if (data.error == 'error_phone_verify') {
                        $('.modal_wrap[data-modal="registerAccountValid"] .js__open_window_now').trigger('click');
                        $('.modal_wrap[data-modal="registerAccountValid"] .js_user_id').val(data.user_id);
                    } else {
                        $('.js__register_b2b_form').find(`input[data-errorReqiest=${data.error}]`).addClass('input_error')
                            .after(`<p class="text_problem text_error">${errorText[data.error]}</p>`);
                    }
                } else {
                    toolsLandingPage.sendSuccess(successModal, false);
                }
            }
        });
    },

    sendSuccess: function (nameForm, account = false) {
        $('.modal_wrap[data-modal=successModal]').find('.modal_middle .account_forgot').addClass('d_none');
        $('.modal_wrap[data-modal=successModal]').find('.modal_middle .all_text')
            .removeClass('d_none');

        if ($('.bg_modal').length == 0) {
            $('footer').after('<div class="bg_modal"></div>');
        }
        if (account) {
            $('.modal_wrap[data-modal=successModal]').find('.modal_middle .all_text').addClass('d_none');
        }

        $('body').find('.text_error').remove();
        $('body').find('.input_error').removeClass('input_error')
        $('.modal_wrap').removeClass('js_open_modal');
        $('.modal_wrap .js__disabled').removeClass('js__disabled');
        $('.modal_wrap[data-modal=successModal]')
            .addClass('js_open_modal').find('.title_modal')
            .empty().text(successText[nameForm]);

        setTimeout(() => {
            $('.modal_wrap[data-modal=successModal]').removeClass('js_open_modal');
            $('.bg_modal').remove();
        }, 5000)
    }
}

$(document).ready(function () {

    let cookieGa = '_ga',
        cookieValueGa = "",
        ga6SKR50Z3WEValue = '_ga_6SKR50Z3WE',
        cookieValuega6SKR50Z3WE = "",
        userAgent = navigator.userAgent,
        gclidValue = "";

    if (document.cookie.indexOf(cookieGa) > -1) {
        cookieValueGa = document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + cookieGa + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1");
        cookieValueGa = cookieValueGa.substring(6);
    }

    if (document.cookie.indexOf(ga6SKR50Z3WEValue) > -1) {
        cookieValuega6SKR50Z3WE = document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + ga6SKR50Z3WEValue + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1");
    }

    let sbjsCookieValue = getCookie('sbjs_current_add');
    if (sbjsCookieValue) {
        let decodedString = decodeURIComponent(sbjsCookieValue)
        let regex = /[?&]gclid=([^&#]*)/;
        let match = regex.exec(decodedString);
        if (match) {
            gclidValue = decodeURIComponent(match[1].replace(/\+/g, ' '));
        }
    }

    function getCookie(name) {
        let value = "; " + document.cookie;
        let parts = value.split("; " + name + "=");
        if (parts.length == 2) {
            return parts.pop().split(";").shift();
        }
    }

    objectSbjs = {
        "utm_source": sbjs.get.current.src,
        "utm_medium": sbjs.get.current.mdm,
        "utm_campaign": sbjs.get.current.cmp,
        "utm_content": sbjs.get.current.cnt,
        "utm_term": sbjs.get.current.trm,
        "client_id": cookieValueGa,
        "session_id": cookieValuega6SKR50Z3WE,
        "gclid": gclidValue,
        "user_agent": userAgent,
    }

    $(document).on('click', '.js__open_menu', function () {
        $(this).toggleClass('active');
        $('.menu_mob').toggleClass('active');

        $('.bg_menu_off').length > 0
            ? $('.bg_menu_off').remove()
            : $('footer').after(`<div class="bg_menu_off"></div>`);

    });

    $(document).on('click', '.bg_menu_off', function () {
        $('.js__open_menu').removeClass('active');
        $('.menu_mob').removeClass('active');
        $('.bg_menu_off').remove()
    });

    $(document).on('click', '.js__open_icon', function () {
        $(this).closest('.lang_list_header').toggleClass('active');
    });


    $('.js__good_landing_list').each(function () {
        loadSlider($(this));
    });


    $(document).on('click', '.js__open_mark', function () {
        if ($(this).hasClass('active')) {
            $(this).closest('.litter_list').find('div:first-child').removeClass('active');
            $(this).removeClass('active');
            $(this).closest('.mark_item').find('.item_list').slideUp();
        } else {
            $('.js__open_mark').removeClass('active');
            $('.item_list').slideUp('active');
            $('.litter_list div:first-child').removeClass('active');

            $(this).closest('.litter_list').find('div:first-child').addClass('active');
            $(this).addClass('active');
            $(this).closest('.mark_item').find('.item_list').slideDown();
        }
    });


    $('.js__assessment_condition_list').each(function () {
        loadMiniSlider($(this));
    });

    $(document).on('click', '.js_button_faqs', function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $(this).closest('.faqs_item').find('.block_faqs').slideUp();
        } else {
            $('.js_button_faqs').removeClass('active');
            $('.block_faqs').slideUp('active');

            $(this).addClass('active');
            $(this).closest('.faqs_item').find('.block_faqs').slideDown();
        }
    })

    $(document).on('click', '.js__anker', function () {
        const name = $(this).attr('data-menu');
        $('.js__open_menu').removeClass('active');
        $('.menu_mob').removeClass('active');
        $('.bg_menu_off').remove();

        let top = $(`#${name}`).offset().top - 150;

        $('body,html').animate({
            scrollTop: top
        }, 1500);
    });

    $(document).on('click', '.js_close_modal, .bg_modal', function () {
        $('.modal_wrap[data-modal=successModal]').removeClass('js_open_modal');
        $('.bg_modal').remove();
    })

    $(document).on('click', '.js_valid_form', function (e) {
        e.stopPropagation();
        e.preventDefault();

        const button = $(this);
        button.addClass('js__disabled');
        const successName = $(this).attr('data-success');

        const typeLanding = $(this).attr('data-landing');

        var dataBOC = {};

        let dataObject = {
            "lang": lang,
            "sbjs": objectSbjs,
            "type": typeLanding
        };

        let nameForm = '';

        if ($(this).hasClass('js__name_form')) {
            nameForm = $(this).attr('data-nameForm');
        } else {
            nameForm = $(this).closest('.modal_wrap').attr('data-modal');
        }

        let errorInput = 0;
        $(this).closest('.js_form_validate').find('.text_error').remove();
        $(this).closest('.js_form_validate').find('.input_error').removeClass('input_error');

        $(this).closest('.js_form_validate')
            .find('input').each(function () {
                if ($(this).is(':required')) {
                    const errorName = $(this).attr('data-error');
                    if ($(this).val() == '') {
                        $(this).addClass('input_error');
                        $(this).after(`<p class="text_problem text_error">${errorText[errorName]}</p>`);

                        errorInput++;
                    } else if (errorName == "phone") {
                        let countNum = $(this).val();
                        countNum = countNum.replace(/\D/g, '').length;
                        if (countNum < 12) {
                            $(this).after(`<p class="text_problem text_error">${errorText['phone_number']}</p>`);
                            $(this).addClass('input_error');
                            errorInput++;
                        } else {
                            $(this).closest('.js_form_validate').find('text_problem').remove();
                            $(this).remove('input_error');
                        }
                    } else if (errorName == "password_error") {
                        if ($(this).val() == "") {
                            $(this).after(`<p class="text_problem text_error">${errorText['password']}</p>`);
                            errorInput++;
                        } else if ($(this).attr('data-new') == "main") {
                            new_pass_one = $(this).val();
                        } else if ($(this).attr('data-new') == "main_two" && new_pass_one != "") {
                            if (new_pass_one != $(this).val()) {
                                $(this).after(`<p class="text_problem text_error">${errorText['password_now']}</p>`);
                                errorInput++;
                            }
                        }
                    } else {
                        $(this).closest('.js_form_validate').find('text_problem').remove();
                    }
                }

                if (errorInput == 0) {
                    if ($(this).attr('type') == 'checkbox' || $(this).attr('type') == 'radio') {
                        if ($(this).attr('name') == 'days') {
                            if ($(this).is(":checked")) {
                                dataObject[$(this).attr('name')] = $(this).val();
                            }
                        } else {
                            if ($(this).is(":checked")) {
                                dataObject[$(this).attr('name')] = $(this).val();
                            } else {
                                dataObject[$(this).attr('name')] = "";
                            }
                        }
                    } else {
                        dataObject[$(this).attr('name')] = $(this).val();
                    }
                } else {
                    button.removeClass('js__disabled');
                }
            });

        if (errorInput == 0) {
            switch (nameForm) {
                case 'loginAccount':
                    toolsLandingPage.account(successName, dataObject, nameForm);
                    break;
                case 'registerAccount':
                    toolsLandingPage.registerAccount(successName, dataObject, nameForm);
                    break;
                case 'registerAccountValid':
                    toolsLandingPage.registerAccountValid(successName, dataObject, nameForm);
                    break;
                case 'registerAccountB2B':
                    toolsLandingPage.registerAccountB2B(successName, dataObject, nameForm);
                    break;
                case 'verification':
                    toolsLandingPage.appointVerifyPhone(successName, dataObject, nameForm);
                    break;
                case 'passwordForgot':
                    toolsLandingPage.passwordForgot(successName, dataObject, nameForm);
                    break;
                default:
                    toolsLandingPage.sendForm(dataObject, successName, typeLanding);
                    $('.js_form_validate .input_input').val('');
            }
        }
    });
    phoneMask();

    $(document).on('click', '.js__view_password', function () {
        $(this).toggleClass('js_active');
        const inputPassword = $(this).closest('.password_view_block').find('input')

        if (inputPassword.attr('type') == "password") {
            inputPassword.attr('type', 'text');
        } else {
            inputPassword.attr('type', 'password');
        }
    });

    $(document).on('input', '.js__mask_phone', function () {
        var phoneNumber = $(this).val().replace(/\D/g, '');

        if (phoneNumber.startsWith('3800')) {
            $(this).val('');
            return;
        }

        var prefix = phoneNumber.substring(3, 5);
        var allowed_prefixes = ['67', '96', '95', '98', '93', '77', '97', '50', '63', '99', '66', '68', '73', '91', '92', '94'];
        if (prefix.length == 2 && allowed_prefixes.indexOf(prefix) === -1) {
            $(this).val('');
        }
    });


    $(document).on('click', '.js__type_ransom_type_btn', function () {
        $(this).toggleClass('open');
        $(this).closest('.input_drop').find('.js__type_ransom_type_list').toggleClass('open');
    })

    $(document).on('click', '.js__item_type_ransom_type_btn', function () {
        const btn = $(this);
        const text = btn.text();
        const value = btn.attr('data-value');

        $('.js__type_ransom_type_btn').empty().text(text);
        $('input[name=ransom_type]').val(value);
        $('.js__type_ransom_type_btn, .js__type_ransom_type_list').removeClass('open');
    });

    $(document).mouseup(function (e) {
        var inputDrop = $(".input_drop");
        if (!inputDrop.is(e.target) && inputDrop.has(e.target).length === 0) {
            $('.js__type_ransom_type_btn, .js__type_ransom_type_list').removeClass('open');
        }
    });

    $(document).on('click', '.js__tabs_btn', function () {
        const btn = $(this);
        const tabs = btn.attr('data-tabs');
        $('.js__tabs_btn').removeClass('active');
        $('.landing_page_tab').removeClass('active');

        $(`.js__tabs_btn[data-tabs=${tabs}]`).addClass('active');
        $(`.landing_page_tab[data-tabs=${tabs}]`).addClass('active');


        if ($(`.landing_page_tab[data-tabs=${tabs}]`).find('.js__good_landing_list').length > 0) {
            $(`.landing_page_tab[data-tabs=${tabs}]`).find('.js__good_landing_list').slick('unslick').removeClass('slick-initialized slick-slider slick-dotted');

            loadSlider($(`.landing_page_tab[data-tabs=${tabs}]`).find('.js__good_landing_list'));
        }


        if ($(`.landing_page_tab[data-tabs=${tabs}]`).find('.js__assessment_condition_list').length > 0) {
            $(`.landing_page_tab[data-tabs=${tabs}]`).find('.js__assessment_condition_list').slick('unslick').removeClass('slick-initialized slick-slider slick-dotted');

            loadMiniSlider($(`.landing_page_tab[data-tabs=${tabs}]`).find('.js__assessment_condition_list'));
        }
    })
});

function loadMiniSlider(slider) {
    slider.slick({
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        prevArrow: slider.closest('.js__slider_wrapper').find('.js__btn_condition_prev'),
        nextArrow: slider.closest('.js__slider_wrapper').find('.js__btn_condition_next'),
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false
                }
            }
        ]
    });
}

function loadSlider(slider) {
    var prevArrow = slider.closest('.js__slider_wrapper').find('.js__btn_examples_rails_prev');
    var nextArrow = slider.closest('.js__slider_wrapper').find('.js__btn_examples_rails_next');

    slider.slick({
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false
                }
            }
        ]
    });

    if (slider.find('.examples_rails_item').length <= 4) {
        slider.closest('.js__slider_wrapper').find('.slick-dots').hide();
    }
}


function listLoad() {
    $('.js__examples_rails_list .name').css('min-height', '')
    $('.js__examples_rails_list').each(function () {
        let maxHeight = 0;
        $(this).find('.name').each(function () {
            if ($(this).outerHeight() > maxHeight) {
                maxHeight = $(this).outerHeight();
            }
        });

        $(this).find('.name').css('min-height', maxHeight);
    })
}

$(window).on('load', function () {
    listLoad();
});

$(window).resize(function () {
    listLoad();
})

function phoneMask() {
    var imUA = new Inputmask("+38(099) 999 99 99");
    imUA.mask($(".js__mask_phone"));
}

$(document).ready(function () {
    $('.js_bg-partners__brands').slick({
        autoplay: true,
        autoplaySpeed: 0,
        speed: 3000,
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: false,
        cssEase: 'linear',
        pauseOnHover: false,
        draggable: false,
        responsive: [
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    autoplay: true,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    autoplay: true,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    autoplay: true,
                }
            }
            , {
                breakpoint: 340,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: true,
                }
            }
        ]
    })

    $('.js_reviews').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    })

    reviewButton()
    isReviewControls()

    $('.js_reviews').on('breakpoint', function () {
        isReviewControls()
    })
})

$(document).on('click', '.js_reviews__btn', function () {
    $(this).toggleClass('active')
    $(this).closest('.js_reviews__text').toggleClass('active')
})

$(document).on('click', '.js_reviews__arrow_prev', function () {
    $('.js_reviews').slick('slickPrev')
    reviewScrollPosition()
})

$(document).on('click', '.js_reviews__arrow_next', function () {
    $('.js_reviews').slick('slickNext')
    reviewScrollPosition()
})

$(window).on('resize', function () {
    reviewButton()
    $('.js_reviews__text').removeClass('active')
    $('.js_reviews__btn').removeClass('active')
})

$(document).on('mouseenter', '.js_bg-partners__brands', function () {
    $('.js_bg-partners__brands').slick('slickPause')
})

$(document).on('mouseleave', '.js_bg-partners__brands', function () {
    $('.js_bg-partners__brands').slick('slickPlay')
})

function reviewButton() {
    $('.js_reviews__text').each((i, el) => {
        let heigth = el.scrollHeight
        let maxHeigth = +(parseFloat(getComputedStyle(el).lineHeight) * 3).toFixed(1)
        if (heigth <= maxHeigth) {
            $(el).find('.js_reviews__btn').css('display', 'none')
        } else {
            $(el).find('.js_reviews__btn').removeAttr('style')
        }
    })
}

function isReviewControls() {
    reviewScroll()
    reviewScrollPosition()
    let showingSlides = ($('.js_reviews').slick('getSlick').options.slidesToShow)
    let slidesCount = $('.js_reviews').find('.slick-slide:not(.slick-cloned)').length
    if (slidesCount <= showingSlides) {
        $('.js_reviews__control').css('display', 'none')
    } else {
        $('.js_reviews__control').removeAttr('style')
    }
}

function reviewScroll(position) {
    let slidesCount = $('.js_reviews').find('.slick-slide:not(.slick-cloned)').length
    let width = 1 / slidesCount * 100
    if (position) {
        return width
    } else {
        $('.js_reviews__scroll').find('span').css('width', width + '%')
    }
}

function reviewScrollPosition() {
    let activeIndex = $('.js_reviews').find('.slick-active').attr('data-item')
    let position = reviewScroll(true) * activeIndex
    $('.js_reviews__scroll').find('span').css('left', position + '%')
}